<!-- ========== Left Sidebar Start ========== -->
<ng-template #contentTemplate>
  <div id="sidebar-menu">
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>

      <!-- Menú principal -->
      <ng-container *ngFor="let item of menuItems">
        <li class="menu-title" *ngIf="item.isTitle">{{ item.label | translate }}</li>

        <li *ngIf="!item.isTitle && !item.isLayout">
          <!-- Item sin hijos -->
          <a *ngIf="!hasItems(item)"
             [routerLink]="item.link"
             class="side-nav-link-ref"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: true }">
            <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
            <span>{{ item.label | translate }}</span>
          </a>

          <!-- Item con hijos (desplegable) -->
          <a *ngIf="hasItems(item)"
             href="javascript:void(0)"
             class="has-arrow waves-effect">
            <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
            <span>{{ item.label | translate }}</span>
          </a>
          <ul class="sub-menu" aria-expanded="false" *ngIf="hasItems(item)">
            <li *ngFor="let child of item.subItems">
              <a [routerLink]="child.link"
                 class="side-nav-link-ref color_text"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{ exact: true }">
                <span>{{ child.label | translate }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ng-container>

    </ul>
  </div>
</ng-template>

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->